import { Alert } from '@dtx-company/design-system/src'
import React from 'react'
import useTranslation from 'next-translate/useTranslation'

const SuccessBanner: React.FC = () => {
  const { t } = useTranslation('email-verification')

  const copy = t('views.SuccessBanner')

  return <Alert severity="success">{copy}</Alert>
}

export default SuccessBanner
